import { render } from "./ModalSolicitudDet.vue?vue&type=template&id=47104cf4"
import script from "./ModalSolicitudDet.vue?vue&type=script&lang=js"
export * from "./ModalSolicitudDet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__